import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Colors } from '../theme'

import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import InputLabel from '@material-ui/core/InputLabel'
import { DatePicker } from 'material-ui-pickers'
import { localize, getLocale } from '../util/Localizer'
import Config from '../Config'

class RBDatePicker extends Component {
  render () {
    const { id = 'datePicker', pickerProps = {} } = this.props

    const defaultedPickerProps = {
      ...pickerProps,
      id,
      label: ' ',
      format: Config.dateFormat, // can't localize this because the date picker does not care
      disableOpenOnEnter: (pickerProps.disableOpenOnEnter !== undefined) ? pickerProps.disableOpenOnEnter : false,
      animateYearScrolling: (pickerProps.animateYearScrolling !== undefined) ? pickerProps.animateYearScrolling : false,
      keyboard: (pickerProps.keyboard !== undefined) ? pickerProps.keyboard : false,
      cancelLabel: localize('common.cancel'),
      locale: getLocale()
    }

    const showErrorText = (typeof this.props.errorText === 'string' && this.props.errorText.length > 0)

    return (
      <FormControl fullWidth={this.props.fullWidth} onBlur={this.props.onBlur}>
        <InputLabel
          htmlFor={id}
          shrink={true}
          style={{ color: Colors.Palette.primaryTextColor }}
        >
          {this.props.label}
        </InputLabel>
        <DatePicker { ...defaultedPickerProps } />
        <FormHelperText error={showErrorText}>
          {this.props.errorText || ''}
        </FormHelperText>
      </FormControl>
    )
  }
}

RBDatePicker.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  errorText: PropTypes.string,
  fullWidth: PropTypes.bool,
  pickerProps: PropTypes.shape(DatePicker.propTypes)
}

export default RBDatePicker



// WEBPACK FOOTER //
// ./src/controls/RBDatePicker.js